export enum CategoryStyleType {
    Style_1,
    Style_2,
    Style_2_1,
    Style_2_2,
    Style_3
}